import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { firebaseInit } from './firebase';
import './index.css';
import { Router } from './router/components/Router';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://e834985ee0994071c9cd8508200517c9@o4508825465585664.ingest.us.sentry.io/4508834943729664',
  enabled: process.env.NODE_ENV !== 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = document.getElementById('root');

firebaseInit();

if (root) {
  createRoot(root).render(
    <StrictMode>
      <Router />
    </StrictMode>
  );
}
